import Vue from 'vue'
import VueRouter from 'vue-router'

//导入公共组件layout
/** 译员端 */
import Layout from '@/components/Layout.vue'
import YedeerLayout from '@/components/YedeerLayout.vue'
import YedeerLayoutPhone from '@/components/YedeerLayoutPhone.vue'

/** 需求端 */
import DemanderLayout from '@/components/demanderComponent/LayoutComponent.vue'
// import { component } from 'vue/types/umd'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
//push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
//replace
VueRouter.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

//配置路由
const routes = [
  /** ************** 需求端页面 ************** */
  /** PC端 需求端 */
  //登录页
  // {
  //   path: '/xqlogin',
  //   name: 'XQLogin',
  //   component:()=> import('@/demander/Login.vue'),
  //   // 一级路由都要配，不用登录就能进去的页面 (false)
  // 	meta: { requiresAuth: false }
  // },
  // 注册页
  // {
  //   path: '/xqregister',
  //   name: 'XQRegister',
  //   component:()=> import('@/demander/Register.vue'),
  //   // 一级路由都要配，不用登录就能进去的页面 (false)
  // 	meta: { requiresAuth: false }
  // },
  // 修改密码页
  // {
  //   path: '/xqreset',
  //   name: 'XQReset',
  //   component:()=> import('@/demander/Reset.vue'),
  //   // 一级路由都要配，不用登录就能进去的页面 (false)
  // 	meta: { requiresAuth: false }
  // },

  // 客服联系页面
  {
    path: '/xqrelationservice',
    name: 'XQRelationService',
    component: () => import('@/demander/RelationService/index.vue'),
    meta: { requiresAuth: false }
  },
  // 公共项目详情页面
  {
    path: '/xqprojectdetail',
    name: 'XQProjectDetail',
    component: () => import('@/demander/PublicPage/index.vue'),
    // 一级路由都要配，不用登录就能进去的页面 (false)
    meta: { requiresAuth: false }
  },
  // Overview页面
  {
    path: '/xqoverview/',
    name: 'XQOverview',
    meta: { requiresAuth: true },
    component: DemanderLayout,
    children: [
      {
        path: 'index',
        name: 'XQOverviewIndex',
        component: () => import('@/demander/Overview/index.vue')
      }
    ]
  },
  {
    path: '/xqbasic/',
    name: 'XQBasic',
    meta: { requiresAuth: true },
    component: DemanderLayout,
    children: [
      {
        path: 'index',
        name: 'XQBasicIndex',
        component: () => import('@/demander/BasicInfomation/index')
      }
    ]
  },
  {
    path: '/xqresume/',
    name: 'XQResume',
    meta: { requiresAuth: true },
    component: DemanderLayout,
    children: [
      {
        path: 'detail',
        name: 'XQResumeDetail',
        component: () => import('@/demander/Resume/ResumeDetail.vue')
      }
    ]
  },
  // 网上联系页面
  {
    path: '/xqonlinecommunication/',
    name: 'XQOnlineCommunication',
    meta: { requiresAuth: true },
    component: DemanderLayout,
    children: [
      {
        path: 'index',
        name: 'XQOnlineCommunicationIndex',
        component: () => import('@/demander/OnlineCommunication/index.vue')
      }
    ]
  },
  {
    path: '/xqpositionmanagement/',
    name: 'PositionManagement',
    meta: { requiresAuth: true },
    component: DemanderLayout,
    children: [
      {
        path: 'index',
        name: 'positionManagement',
        component: () => import('@/demander/PositionManagement/index.vue')
      },
      {
        path: 'resumedelivery',
        name: 'resumeDelivery',
        component: () =>
          import('@/demander/PositionManagement/resumeDelivery.vue')
      },
      {
        path: 'addedit',
        name: 'AddAndEdit',
        component: () =>
          import(
            '@/demander/PositionManagement/PositionManagementEditAndAdd.vue'
          )
      },
      {
        path: 'positiondetail',
        name: 'PositionDetail',
        component: () =>
          import('@/demander/PositionManagement/Positions/PositionDetail.vue')
      },
      {
        path: 'positionresume',
        name: 'PositionResume',
        component: () =>
          import('@/demander/PositionManagement/Positions/PositionResume.vue')
      },
      // R人才评价
      {
        path: 'peopleevaluation',
        name: 'PeopleEvaluation',
        component: () =>
          import('@/demander/PeopleManagement/PeopleEvaluation.vue')
      }
    ]
  },
  // offer 管理
  {
    path: '/xqoffermanagement/',
    name: 'OfferManagement',
    meta: { requiresAuth: true },
    component: DemanderLayout,
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/demander/OfferManagement/index.vue')
      },
      // 发送订单
      {
        path: 'initiateAnOrder',
        name: 'initiateAnOrder',
        component: () =>
          import('@/demander/OfferManagement/initiateAnOrder.vue')
      },
      // 发送订单 需求 详情
      {
        path: 'initiateAnOrderXQ',
        name: 'initiateAnOrderXQ',
        component: () =>
          import('@/demander/OfferManagement/initiateAnOrderXQ.vue')
      }
    ]
  },
  // 评价 管理
  {
    path: '/xqevaluateManagement/',
    name: 'EvaluateManagement',
    meta: { requiresAuth: true },
    component: DemanderLayout,
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/demander/evaluateManagement/index.vue')
      }
    ]
  },
  // 申诉 管理
  {
    path: '/xqappealManagement/',
    name: 'AppealManagement',
    meta: { requiresAuth: true },
    component: DemanderLayout,
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/demander/AppealManagement/index.vue')
      },
      {
        path: 'details',
        name: 'details',
        component: () => import('@/demander/AppealManagement/appealDetails.vue')
      }
    ]
  },
  // 人才管理
  {
    path: '/xqpeoplemanagement/',
    name: 'PeopleManagement',
    meta: { requiresAuth: true },
    component: DemanderLayout,
    children: [
      {
        path: 'index',
        name: 'PeopleManagementIndex',
        component: () => import('@/demander/PeopleManagement/index.vue')
      },
      {
        path: 'projecttable',
        name: 'PeopleManagementProjectTable',
        component: () =>
          import('@/demander/PeopleManagement/ProjectTableList.vue')
      }
    ]
  },
  // 我的消息
  {
    path: '/xqmessagecenter/',
    name: 'XQMessageCenter',
    meta: { requiresAuth: true },
    component: DemanderLayout,
    children: [
      {
        path: 'xqmessagefeedback',
        name: 'XQMessageFeedback',
        component: () => import('@/demander/MessageCenter/index.vue')
      },
      {
        path: 'xqmessagedetail',
        name: 'XQMessageDetail',
        component: () => import('@/demander/MessageCenter/MessageDetail.vue')
      }
    ]
  },

  // 安全设置
  {
    path: '/xqsetting/',
    name: 'Setting',
    meta: { requiresAuth: true },
    component: DemanderLayout,
    children: [
      {
        path: 'index',
        name: 'SettingIndex',
        component: () => import('@/demander/Settings/index.vue')
      }
    ]
  },

  /** ************ 译员端页面 ************** */
  /** PC端 译员端 */
  // PC登录
  {
    path: '/login', //登录页
    name: 'Login',
    component: () => import('@/views/Login'),
    // 一级路由都要配，不用登录就能进去的页面 (false)
    meta: { requiresAuth: false }
  },
  // Yedeer 小程序
  {
    path: '/yedeerMiniProgram',
    name: 'YedeerMiniProgram',
    component: () => import('@/views/YedeerMiniProgram/YedeerMiniProgram'),
    meta: { requiresAuth: false }
  },
  // PC系统维护
  {
    path: '/update', //注册页
    name: 'Update',
    component: () => import('@/views/Update.vue'),
    meta: { requiresAuth: false }
  },
  // PC注册
  {
    path: '/register', //注册页
    name: 'Register',
    component: () => import('@/views/Register'),
    meta: { requiresAuth: false }
  },
  // PC重置密码
  {
    path: '/reset', //修改密码页
    name: 'Reset',
    component: () => import('@/views/Reset'),
    meta: { requiresAuth: false }
  },

  /** 手机端 译员端 */
  // phone登录
  {
    path: '/phonelogin',
    name: 'PhoneLogin',
    component: () => import('@/views/Yedeer/Phone/phoneLogin.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/wechatLogin',
    name: 'WechatLogin',
    component: () => import('@/views/wechatLogin.vue'),
    meta: { requiresAuth: false }
  },
  // phone注册页
  {
    path: '/phoneregister',
    name: 'PhoneRegister',
    component: () => import('@/views/Yedeer/Phone/phoneRegister.vue'),
    meta: { requiresAuth: false }
  },
  // phone概览页
  {
    path: '/overview/', //主页
    name: 'Overview',
    meta: { requiresAuth: true }, //需要登录才能进入
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'overviewindex',
        component: () => import('@/views/Overview')
      }
    ]
  },
  // 网上聊天
  {
    path: '/onlinecommunication/', //主页
    name: 'OnlineCommunication',
    meta: { requiresAuth: true }, //需要登录才能进入
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'OnlineCommunicationindex',
        component: () => import('@/views/OnlineCommunication')
      }
    ]
  },
  // 个人中心
  {
    path: '/personalcenter/', //个人中心
    name: 'PersonalCenter',
    meta: { requiresAuth: true },
    component: Layout,
    children: [
      {
        path: 'basicinformation',
        name: 'BasicInformation',
        component: () => import('@/views/PersonalCenter/BasicInformation.vue')
      },
      {
        path: 'myresume',
        name: 'MyResume',
        component: () => import('@/views/PersonalCenter/MyResume.vue')
      },
      // 语言测试页
      {
        path: 'languagetest',
        name: 'LanguageTest',
        component: () => import('@/views/PersonalCenter/LanguageTest.vue')
      },
      // 可测试语种队
      {
        path: 'languagetestteam',
        name: 'LanguageTestTeam',
        component: () => import('@/views/PersonalCenter/LanguageTestTeam.vue')
      },
      //语言测试状态
      {
        path: 'languageteststatus',
        name: 'LanguageTestStatus',
        component: () => import('@/views/PersonalCenter/LanguageTestStatus.vue')
      },
      {
        path: 'personalverification',
        name: 'PersonalVerification',
        component: () =>
          import('@/views/PersonalCenter/PersonalVerification.vue')
      }
    ]
  },
  // 语言测试中--做题页面
  {
    path: '/languagetesttitle',
    name: 'LanguageTestTitle',
    meta: { requiresAuth: true }, //需要登录才能进入
    component: () => import('@/views/PersonalCenter/LanguageTest/TestTitle.vue')
  },
  //项目中心
  {
    path: '/projectcenter/',
    name: 'ProjectCenter',
    meta: { requiresAuth: true },
    component: Layout,
    children: [
      {
        path: 'projectlist',
        name: 'ProjectList',
        component: () => import('@/views/ProjectCenter/ProjectCenterList.vue')
      },
      {
        path: 'projectdetail',
        name: 'ProjectDetail',
        component: () => import('@/views/ProjectCenter/ProjectDetail.vue')
      }
    ]
  },
  //结算中心
  {
    path: '/settlementcenter/', //结算中心
    name: 'SettlementCenter',
    meta: { requiresAuth: true },
    component: Layout,
    children: [
      //申请记录
      {
        path: 'settlementApplicationRecord',
        name: 'SettlementApplicationRecord',
        component: () =>
          import('@/views/SettlementCenter/SettlementApplicationRecord.vue')
      },
      //费用明细
      {
        path: 'expensedetail',
        name: 'ExpenseDetail',
        component: () => import('@/views/SettlementCenter/ExpenseDetail.vue')
      },
      {
        path: 'settlement',
        name: 'Settlement',
        component: () => import('@/views/SettlementCenter/Settlement.vue')
      },
      //费用结算
      {
        path: 'expensesettlement',
        name: 'ExpenseSettlement',
        component: () =>
          import('@/views/SettlementCenter/ExpenseSettlement.vue')
      },
      // 结算状态
      {
        path: 'settlementstatus',
        name: 'SettlementStatus',
        component: () =>
          import(
            '@/views/SettlementCenter/SettlementStatus/SettlementStatus.vue'
          )
      }
    ]
  },
  // 任务大厅
  {
    path: '/jobhall/', //结算中心
    name: 'JobHall',
    meta: { requiresAuth: true },
    component: Layout,
    children: [
      {
        path: 'joblist',
        name: 'JobList',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/JobHall/JobList.vue')
      },
      {
        path: 'jobdetail',
        name: 'JobDetail',
        component: () => import('@/views/JobHall/JobDetail.vue')
      },
      {
        path: 'applicationrecord',
        name: 'ApplicationRecord',
        component: () => import('@/views/JobHall/ApplicationRecord.vue')
      },
      {
        path: 'evaluateRecord',
        name: 'EvaluateRecord',
        component: () => import('@/views/JobHall/EvaluateRecord.vue')
      },
      {
        path: 'applicationdetail',
        name: 'ApplicationDetail',
        component: () => import('@/views/JobHall/ApplicationDetail.vue')
      }
    ]
  },
  // 任务大厅
  {
    path: '/order/', //结算中心
    name: 'Order',
    meta: { requiresAuth: true },
    component: Layout,
    children: [
      // 订单列表
      {
        path: 'initiateAnOrderIndex',
        name: 'InitiateAnOrderIndex',
        component: () => import('@/views/JobHall/initiateAnOrderIndex.vue')
      },
      {
        path: 'initiateAnOrderYY',
        name: 'InitiateAnOrderYY',
        component: () => import('@/views/JobHall/initiateAnOrderYY.vue')
      },
      {
        path: 'AppealManagementYYIndex',
        name: 'AppealManagementYYIndex',
        component: () => import('@/views/AppealManagementYY/indexYY.vue')
      },
      {
        path: 'appealDetailsYY',
        name: 'appealDetailsYY',
        component: () =>
          import('@/views/AppealManagementYY/appealDetailsYY.vue')
      }
    ]
  },
  //安全中心
  {
    path: '/settings/',
    name: 'Settings',
    meta: { requiresAuth: true },
    component: Layout,
    children: [
      {
        path: 'settingsindex',
        name: 'SettingsIndex',
        component: () => import('@/views/Settings/index.vue')
      }
    ]
  },
  // 消息中心
  {
    path: '/messagecenter/', //消息中心
    name: 'MessageCenter',
    meta: { requiresAuth: true },
    component: Layout,
    children: [
      {
        path: 'messagefeedback',
        name: 'MessageFeedback',
        component: () => import('@/views/MessageCenter/index.vue')
      },
      {
        path: 'messagedetail',
        name: 'MessageDetail',
        component: () => import('@/views/MessageCenter/MessageDetail.vue')
      }
    ]
  },
  //Yedeer网站
  {
    path: '/', //消息中心
    name: 'Yedeers',
    component: YedeerLayout,
    meta: { requiresAuth: false },
    children: [
      // 网站首页
      {
        alias: '/',
        path: 'yedeersindex',
        name: 'YedeersIndex',
        component: () => import('@/views/Yedeer/index.vue')
      },
      // AboutYedeer
      {
        path: 'aboutyedeer',
        name: 'AboutYedeer',
        component: () => import('@/views/Yedeer/AboutYedeer.vue')
      }
    ]
  },
  // 中转跳转页面
  {
    path: '/askwhat',
    name: 'AskWhat',
    meta: { requiresAuth: false },
    component: () => import('@/views/Yedeer/DialogForm/loginAsk')
  },
  //Yedeer网站手机端
  {
    path: '/',
    name: 'YedeersPhone',
    component: YedeerLayoutPhone,
    meta: { requiresAuth: false },
    children: [
      // 网站首页
      {
        path: 'phoneindex',
        name: 'Index',
        component: () => import('@/views/Yedeer/Phone/index.vue')
      },
      // AboutYedeer
      {
        path: 'phoneaboutyedeer',
        name: 'PhoneAboutYedeer',
        component: () => import('@/views/Yedeer/Phone/PhoneAboutYedeer.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history', //hash
  base: process.env.BASE_URL,
  routes
})

export default router

router.beforeEach((to, from, next) => {
  // 1.如果访问的是登录页面（无需权限），直接放行
  /**
   * to.path === '/xqregister' ||
      to.path === '/xqreset' ||
      to.path === '/xqlogin' ||
   */

  if (
    to.path === '/' ||
    to.path === '/login' ||
    to.path === '/register' ||
    to.path === '/resetpassword' ||
    to.path === '/reset' ||
    to.path === '/yedeersindex' ||
    to.path === '/aboutyedeer' ||
    to.path === '/askwhat' ||
    to.path === '/phoneindex' ||
    to.path === '/phoneaboutyedeer' ||
    to.path === '/phonelogin' ||
    to.path === '/phoneregister' ||
    to.path === '/yedeerMiniProgram' ||
    to.path === 'xqresume/detail' ||
    to.path === '/jobhall/jobdetail' ||
    to.path === '/xqprojectdetail' ||
    to.path === '/xqrelationservice' ||
    to.path === '/wechatLogin'
  ) {
    // // Browser environment sniffing
    const inBrowser = typeof window !== 'undefined'
    const inWeex =
      typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform
    const weexPlatform = inWeex && WXEnvironment.platform.toLowerCase()
    const UA = inBrowser && window.navigator.userAgent.toLowerCase()
    // const isIE = UA && /msie|trident/.test(UA)
    // const isIE9 = UA && UA.indexOf('msie 9.0') > 0
    // const isEdge = UA && UA.indexOf('edge/') > 0
    const isAndroid =
      (UA && UA.indexOf('android') > 0) || weexPlatform === 'android'
    const isIOS =
      (UA && /iphone|ipad|ipod|ios/.test(UA)) || weexPlatform === 'ios'
    // const isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge
    // const isPhantomJS = UA && /phantomjs/.test(UA)
    // const isFF = UA && UA.match(/firefox\/(\d+)/)
    if (isAndroid || isIOS) {
      //手机端
      if (to.path === '/' || to.path === '/yedeersindex') {
        next('/phoneindex')
      }
      if (to.path === '/aboutyedeer') {
        next('/phoneaboutyedeer')
      }
      if (to.path === '/login') {
        next('/phonelogin')
      }
      // if (to.path === '/wechatLogin') {
      //   next('/wechatLogin')
      // }
      if (to.path === '/register') {
        if (
          to.query.yqm != '' &&
          to.query.yqm != undefined &&
          to.query.yqm != null &&
          to.query.yqm != 'undefined'
        ) {
          let urlsQuery = to.query
          next('/phoneregister?yqm=' + urlsQuery.yqm)
        } else if (
          to.query.RWID != '' &&
          to.query.RWID != undefined &&
          to.query.RWID != null &&
          to.query.RWID != 'undefined'
        ) {
          let urlsQuery = to.query
          next('/phoneregister?RWID=' + urlsQuery.RWID)
        } else {
          next('/phoneregister')
        }
      }
      if (to.path === '/login') {
        if (
          to.query.RWID != '' &&
          to.query.RWID != undefined &&
          to.query.RWID != null &&
          to.query.RWID != 'undefined'
        ) {
          let urlsQuery = to.query
          next('/phonelogin?RWID=' + urlsQuery.RWID)
        } else {
          next('/phonelogin')
        }
      }
    } else {
      // PC端
      if (to.path === '/phoneindex') {
        next('/yedeersindex')
      }
      if (to.path === '/phoneaboutyedeer') {
        next('/aboutyedeer')
      }
      if (to.path === '/wechatLogin') {
        next('/')
      }
      if (to.path === '/phonelogin') {
        next('/login')
      }
      if (to.path === '/phoneregister') {
        if (
          to.query.yqm != '' &&
          to.query.yqm != undefined &&
          to.query.yqm != null &&
          to.query.yqm != 'undefined'
        ) {
          let urlsQuery = to.query
          next('/register?yqm=' + urlsQuery.yqm)
        } else if (
          to.query.RWID != '' &&
          to.query.RWID != undefined &&
          to.query.RWID != null &&
          to.query.RWID != 'undefined'
        ) {
          let urlsQuery = to.query
          next('/register?RWID=' + urlsQuery.RWID)
        } else {
          next('/register')
        }
      }
      if (to.path === '/phonelogin') {
        if (
          to.query.RWID != '' &&
          to.query.RWID != undefined &&
          to.query.RWID != null &&
          to.query.RWID != 'undefined'
        ) {
          let urlsQuery = to.query
          next('/login?RWID=' + urlsQuery.RWID)
        } else {
          next('/login')
        }
      }
    }
    return next()
  }
  // 2.如果访问的是有登录权限的页面，先要获取token
  const token = window.localStorage.getItem('token')
  // 2.1如果token为空，强制跳转到登录页面；否则，直接放行
  if (!token) {
    // 弹出弹窗提示 - 跳转到译员端登录页
    Vue.prototype.$message.error('Please login!')
    return next('/login')
    // 判断路由是需求端还是译员端
    /*// 需求端
    if(to.path.indexOf('/xq') != -1){
      // 弹出弹窗提示 - 跳转到需求端登录页
      Vue.prototype.$message.error('Please login!');
      return next('/xqlogin')
    }else{ // 译员端
      // 弹出弹窗提示 - 跳转到译员端登录页
      Vue.prototype.$message.error('Please login!');
      return next('/login')
    } */
  }

  next()
})
